import React from 'react';

const Wallet = () => {
  return (
    <>
      {' '}
      <h2>Your Wallet</h2>
    </>
  );
};

export default Wallet;
